var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.2C7 5.16291 7 4.64437 7.3417 4.32218C7.68342 4 8.23339 4 9.33333 4H11.3912C12.0928 4 12.4437 4 12.7256 4.16429C13.0075 4.32857 13.1644 4.62443 13.4783 5.21613L14.5833 7.3H18.6667C19.7666 7.3 20.3166 7.3 20.6583 7.62218C21 7.94437 21 8.46291 21 9.5V12.8C21 13.8371 21 14.3556 20.6583 14.6778C20.3166 15 19.7666 15 18.6667 15H9.33333C8.23339 15 7.68342 15 7.3417 14.6778C7 14.3556 7 13.8371 7 12.8V6.2Z",
    stroke: "#8890A6",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.2727V18.1091C18 18.771 18 19.1019 17.8742 19.3547C17.7636 19.5771 17.5872 19.7578 17.37 19.8712C17.1232 20 16.8001 20 16.1538 20H4.84615C4.19994 20 3.87683 20 3.63001 19.8712C3.4129 19.7578 3.23639 19.5771 3.12576 19.3547C3 19.1019 3 18.771 3 18.1091V8.89091C3 8.22903 3 7.89809 3.12576 7.64528C3.23639 7.42291 3.4129 7.24212 3.63001 7.12881C3.87683 7 4.19994 7 4.84615 7H7.61538",
    stroke: "#8890A6",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolder);
export default __webpack_public_path__ + "static/media/ic_folder.ab469bb3e65ec020850d5168617a30a1.svg";
export { ForwardRef as ReactComponent };